import { FC, useEffect } from 'react';
import { useStyles } from './styles';
import { RecoveryRequestForm } from 'components/Forms';
import EndUserHeader from 'components/Headers/EndUserHeader/EndUserHeader';
import EndUserFooter from 'components/Headers/EndUserFooter/EndUserFooter';
import Easy from '../../assets/easyidentity.jpg';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useQuery } from 'react-query';
import { observer } from 'mobx-react-lite';
import { ForgetProps } from './type';
import { Grid } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React from 'react';

const UserForgotPassword: FC<ForgetProps> = observer(({ type = 'general' }) => {
  const classes = useStyles();
  useEffect(() => {
    document.title = 'EasyIdentity: User Forgot Password';
  }, []);
  const {
    endUserSettingsFormStore: { getPortalSettings, endUserConfigSettings, getSetting, settingsByTypeView },
    notificationStore: { openNotification },
  } = useStore();
  const getSettingsReq = useQuery('getSettingsReq', () => getSetting(), {
    onError: () => openNotification('error', `Can't get settings data`),
  });
  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => getPortalSettings(), {
    onError: () => openNotification('error', `Can't get data`),
  });
  const bodyStyle = {
    backgroundImage: `url(${endUserConfigSettings?.bannerImage || Easy})`,
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
  };
  useAppPreloader(portalSettingsgetReq.isLoading || getSettingsReq.isFetching);
  return (
    <div className={classes.container} style={bodyStyle}>
      <div>
        <EndUserHeader />
      </div>
      {settingsByTypeView(type).map((group, i) => (
        <>
          {group.settings.map((setting, j) => (
            <React.Fragment key={i}>
              {setting.description === 'Enable Self-Service UserID/Password Recovery' &&
              (setting.value === '0' || setting.value === '') ? (
                <div className={classes.alertContainer}>
                  <div className={classes.alertboxes}>
                    <Grid className={classes.alertmessage}>
                      <div className={classes.alertbox}>
                        <div>
                          <ErrorOutlineIcon className={classes.alertIcon} />
                        </div>
                        <div>
                          <div className={classes.alertTitle}>Administrator did not enable these services</div>
                        </div>
                      </div>
                    </Grid>
                  </div>
                </div>
              ) : setting.description === 'Enable Self-Service UserID/Password Recovery' && setting.value === '1' ? (
                <React.Fragment key={j}>
                  <RecoveryRequestForm type='admin-forgot-password' title='Forgot Password' />
                </React.Fragment>
              ) : null}
            </React.Fragment>
          ))}
        </>
      ))}
      <EndUserFooter />
    </div>
  );
});

export default UserForgotPassword;
